"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGQLHeaders = exports.getProxyCookieProperties = exports.getSourceCookieProperties = exports.getDeviceIdCookieProperties = exports.getSessionCookieProperties = exports.SESSION_LENGTH_HOURS = exports.getSession = exports.serializeSessionCookie = exports.deserializeSessionCookie = exports.getSource = exports.getDeviceId = exports.getMaxEpiration = void 0;
const Constants_1 = require("../Constants");
const isSession_1 = require("../sessions/isSession");
const Cookies_1 = require("./Cookies");
function getMaxEpiration() {
    return new Date(Date.now() + Constants_1.Time.ONE_YEAR_IN_MS * 10);
}
exports.getMaxEpiration = getMaxEpiration;
function getValueWithHeadersFallback(req, key) {
    var _a, _b;
    return ((_a = req.headers) === null || _a === void 0 ? void 0 : _a[key]) || ((_b = req.cookies) === null || _b === void 0 ? void 0 : _b[key]);
}
function getDeviceId(req) {
    return getValueWithHeadersFallback(req, Cookies_1.COOKIE_DEVICE_ID);
}
exports.getDeviceId = getDeviceId;
function getSource(req) {
    return getValueWithHeadersFallback(req, Cookies_1.COOKIE_SOURCE);
}
exports.getSource = getSource;
const deserializeSessionCookie = (session) => {
    const decoded = session.endsWith('=') ? Buffer.from(session, 'base64').toString() : session;
    const parsedSession = JSON.parse(decoded);
    return (0, isSession_1.isSession)(parsedSession) ? parsedSession : null;
};
exports.deserializeSessionCookie = deserializeSessionCookie;
const serializeSessionCookie = (session) => {
    return Buffer.from(JSON.stringify(session)).toString('base64');
};
exports.serializeSessionCookie = serializeSessionCookie;
function getSession(req) {
    var _a, _b;
    const startedAt = ((_a = req.headers) === null || _a === void 0 ? void 0 : _a['x-sst']) ? parseInt(String(req.headers['x-sst']), 10) : Date.now();
    const oldHeaderBasedSession = ((_b = req.headers) === null || _b === void 0 ? void 0 : _b['x-sid'])
        ? {
            id: req.headers['x-sid'],
            startedAt,
            updatedAt: startedAt,
        }
        : null;
    const cookie = getValueWithHeadersFallback(req, Cookies_1.COOKIE_SESSION_KEY);
    return cookie ? (0, exports.deserializeSessionCookie)(cookie) : oldHeaderBasedSession;
}
exports.getSession = getSession;
exports.SESSION_LENGTH_HOURS = 6;
function getSessionCookieProperties(domain) {
    const expiration = new Date(Date.now() + exports.SESSION_LENGTH_HOURS * Constants_1.Time.ONE_HOUR_IN_MS);
    return { secure: false, expires: expiration, httpOnly: false, overwrite: true, domain };
}
exports.getSessionCookieProperties = getSessionCookieProperties;
function getDeviceIdCookieProperties(domain) {
    const expiration = getMaxEpiration();
    return { secure: false, expires: expiration, httpOnly: false, overwrite: true, domain };
}
exports.getDeviceIdCookieProperties = getDeviceIdCookieProperties;
function getSourceCookieProperties(domain) {
    const expiration = getMaxEpiration();
    return { secure: false, expires: expiration, httpOnly: false, overwrite: true, domain };
}
exports.getSourceCookieProperties = getSourceCookieProperties;
function getProxyCookieProperties(domain) {
    const expiration = getMaxEpiration();
    return { secure: false, expires: expiration, httpOnly: true, overwrite: true, domain };
}
exports.getProxyCookieProperties = getProxyCookieProperties;
const getGQLHeaders = (browserTrackerId, source, session) => {
    const headers = {
        [Cookies_1.COOKIE_SOURCE]: source,
        [Cookies_1.COOKIE_DEVICE_ID]: browserTrackerId,
    };
    if (session) {
        headers[Cookies_1.COOKIE_SESSION_KEY] = (0, exports.serializeSessionCookie)(session);
    }
    return headers;
};
exports.getGQLHeaders = getGQLHeaders;
//# sourceMappingURL=CookieUtils.js.map